import React, { Component } from "react";
import InvestorData from "./investorData";
export default class Investor extends Component {
  render() {
    return (
      <div style={{ margin: "20px 8px 30px 8px",paddingBottom:20 }}>
        <div className="investor-title">Transact</div>
        <InvestorData
          history={this.props.history}
          location={this.props.location}
        />
      </div>
    );
  }
}
